import React from "react";
import {map} from "lodash";
import * as storage from "../../utils/storage";
import {FontIcon} from "react-md";
import {FileUploader} from "./FileUploader";
import {TouchVerticalValue_2} from "../../AtollonTheme/ReactElements";
import Translate from "../../Atollon/Translation";
import {isEmpty} from "lodash";
import {getApiPrefix_lagoon} from "../../constants";

const downloadRequestAttachmentByUrl = ({ request, item, storage }) =>
{
    const requestHash = request.hash;
    const itemId = item.id;
    const authorizationToken = storage.get("token");
    const fileUrl = `${getApiPrefix_lagoon()}/auth/request/${requestHash}/file/${itemId}?bearer=${authorizationToken}&download=true`;
    return fileUrl;
};

const downloadRequestAttachment = ({ request, item, storage }) =>
{
    const requestHash = request.hash;
    const itemId = item.id;
    const authorizationToken = storage.get("token");
    const fileUrl = `${getApiPrefix_lagoon()}/auth/request/${requestHash}/file/${itemId}`;
    const fetchParameters = { headers: { "Authorization":  `Bearer ${authorizationToken}` }};
    const fileName = item.name;
    downloadFileNow({ fileUrl, fileName, fetchParameters });
};

const downloadFileNow = async ({ fileUrl, fileName, fetchParameters }) =>
{
    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    // TODO: Download file with header. Should be handled by backend.
    try
    {
        const response = await fetch( fileUrl, fetchParameters );
        const binaryDataBlob = await response.blob();
        const objectURL = URL.createObjectURL( binaryDataBlob ); // File or Blob -> url
        {
            const openerA = document.createElement( 'a' );
            openerA.download = fileName;
            openerA.href = objectURL;
            openerA.click();
        }
        URL.revokeObjectURL( objectURL ); // browser does not know how to cleanup files
    }
    catch( exception )
    {
        alert( Translate( "Nelze stáhnout soubor" ));
    }
};

export const RequestDetailInfoAttachments = ({ request }) =>
{
    if( !isEmpty( request.attachments ))
    {
        return (
                <TouchVerticalValue_2
                    title={(
                        <div>
                            <FontIcon className="touchIcon-highligted_onTheLeftSide color-white">link</FontIcon>
                            <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>{ Translate( "Přílohy" ) }</span>
                        </div>
                    )}
                    value={(
                        <div className="touchRequestDetail-attachment">
                            {
                                map( request.attachments, ( item, uniqueReactKey ) => {
                                    return (
                                        <div key={uniqueReactKey}>
                                            <div
                                                className="touchRequestDetail-attachment-name"
                                            >
                                                <a
                                                    href={downloadRequestAttachmentByUrl({ request, item, storage })}
                                                >
                                                    <FontIcon>file_download</FontIcon>
                                                    {item.kind}: {item.name}
                                                </a>
                                            </div>
                                            <div className="touchRequestDetail-attachment-nameSpaceBetweenNames" />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    )}
                />
        );
    }
    else
    {
        return <div/>;
    }
};


// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestDetailInfoAttachments.js